import { useSuspenseQuery } from "@tanstack/react-query";
import React from "react";
import { useLoaderData } from "react-router";

import type { InsightsLoaderReturn } from "../loader";
import { internalInsightsRouteDataQuery } from "../utils/route-data-query";

export default function withNotFoundFallback<TProps>(ComponentToRender: React.FC<TProps>): React.FC<TProps> {
  return (props) => {
    const { customerDomain }: InsightsLoaderReturn = useLoaderData();
    const {
      data: { isMultistore },
    } = useSuspenseQuery(internalInsightsRouteDataQuery(customerDomain));
    if (!isMultistore) {
      // TODO: use <Navigate> when route is client-side routed.
      window.location.href = "/404";
    }
    return <ComponentToRender {...props} />;
  };
}
